export const HexNumber = {
  print: ({ node }) => node.value
};
